import React from 'react';
import styled from 'styled-components';
// import { rhythm } from "../../utils/typography";

const Ol = styled.ol`
  list-style:none;
  li::marker {
    content: counter(list-item) ".  "; 
    color: var(--color-secondary);
  }
`
const Ul = styled.ul`
  list-style:none;
  li::marker{
    display:inline-block;
    content: "›  "; 
    color: var(--color-secondary);
    padding-right: 6px;
  }
`


export const OrderedList = (props) => {
  return <Ol {...props} />;
}


export const UnorderedList = (props) => {
  return <Ul {...props} />;
}


